import { useCallback, useState } from 'react'

interface DndState {
  draggedBlocoId: string | null
  draggedOverColumn: string | null
}

export function useBlocosDnd(onDrop: (blocoId: string, columnId: string) => void) {
  const [state, setState] = useState<DndState>({
    draggedBlocoId: null,
    draggedOverColumn: null,
  })

  const handleDragStart = useCallback((e: React.DragEvent, blocoId: string) => {
    e.dataTransfer.setData('text/plain', blocoId)
    e.dataTransfer.effectAllowed = 'move'
    setState({ draggedBlocoId: blocoId, draggedOverColumn: null })
  }, [])

  const handleDragEnd = useCallback(() => {
    setState({ draggedBlocoId: null, draggedOverColumn: null })
  }, [])

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
  }, [])

  const handleDragEnter = useCallback((e: React.DragEvent, columnId: string) => {
    e.preventDefault()
    setState((prev) => ({ ...prev, draggedOverColumn: columnId }))
  }, [])

  const handleDragLeave = useCallback((e: React.DragEvent, columnId: string) => {
    const related = e.relatedTarget as Node | null
    if (related && e.currentTarget.contains(related)) return
    setState((prev) => (prev.draggedOverColumn === columnId ? { ...prev, draggedOverColumn: null } : prev))
  }, [])

  const handleDrop = useCallback(
    (e: React.DragEvent, columnId: string) => {
      e.preventDefault()
      const blocoId = e.dataTransfer.getData('text/plain')
      if (blocoId) onDrop(blocoId, columnId)
      setState({ draggedBlocoId: null, draggedOverColumn: null })
    },
    [onDrop],
  )

  return {
    ...state,
    handleDragStart,
    handleDragEnd,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
  }
}
